import { IUser } from "types/user/user.type";

export default class BusinessRulesHelper {
  static hasEnoughCredits(user: IUser) {
    return user.creditBalance > 0;
  }
}
